import t, { forwardRef as p } from "react";
import { ark as d } from "@ark-ui/react";
import { styled as i, Center as f } from "@huspy/styled-system/jsx";
import { button as g } from "@huspy/styled-system/recipes";
import { Spinner as x } from "../spinner/spinner.mjs";
const E = (e) => {
  switch (e) {
    case "xs":
      return "sm";
    case "sm":
      return "sm";
    case "md":
      return "md";
    case "lg":
      return "lg";
    case "xl":
      return "lg";
    case "xxl":
      return "lg";
    default:
      return "md";
  }
}, b = i(d.button, g), y = p((e, l) => {
  const { variant: r, size: n, loading: a, disabled: m, loadingText: o, children: s, ...c } = e, u = r === "primary" ? "light" : "dark";
  return /* @__PURE__ */ t.createElement(b, { disabled: m, variant: r, size: n, loading: a, ref: l, ...c }, a && !o ? /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(f, { inline: !0, position: "absolute", transform: "translate(-50%, -50%)", top: "50%", insetStart: "50%" }, /* @__PURE__ */ t.createElement(x, { color: u, size: E(n) })), /* @__PURE__ */ t.createElement(i.span, { opacity: 0 }, s)) : o || s);
});
y.displayName = "Button";
export {
  b as BriksButton,
  y as Button
};
